$ = require 'jquery'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
_ = require 'underscore'

module.exports = new class
  idNotLoggedIn = 'notLoggedIn'
  memberId = null
  token = null
  tokenName = "token#{window.location.port}"

  constructor: ->
    @updateToken()

  isLoggedIn: -> memberId != idNotLoggedIn
  myId:       -> memberId
  myUsername: -> @me()?.get('username')
  myToken:    -> token
  me:         ->
    me = ModelCache.get('Member', memberId)
    if !me? && !@isLoggedIn()
      me = new Member({ id: idNotLoggedIn, notLoggedIn: true }, { modelCache: ModelCache })
      ModelCache.add(me)
    me
  # Returns true if the member or member id passed in is the logged in member
  isMe: (memberOrId) ->
    if (memberOrId?.id)
      @isMe(memberOrId.id)
    else
      memberOrId == memberId

  confirmed: ->
    return @me().get('confirmed')

  canLogIn: ->
    return !_.isEmpty(@me()?.get('loginTypes') ? [])

  updateToken: ->
    newToken = $.cookie(tokenName) || ""
    if token != newToken
      token = newToken
      memberId = token.split('/')[0] || idNotLoggedIn
    memberId

  logoutPost: ->
    $dscInput = $('<input>')
    .attr('name', 'dsc')
    .val($.cookie('dsc'))

    $('<form>')
    .attr({ method: 'post', action: '/logout' })
    # A cookie alone is not enough, because that leaves us
    # vulnerable to CSRF.
    .append($dscInput)
    .css({ display: 'none' })
    .appendTo('body')
    .submit()

  removeToken: ->
    $.cookie(tokenName, null, { path: '/' })
    window.location.reload()



// WEBPACK FOOTER //
// ./app/scripts/db/auth.coffee